import React from 'react';
import { Star } from 'lucide-react';
import VendorReviews from '../VendorReviews';

const ReviewsTab = ({ serviceRating, serviceReviews, serviceRatingStats, vendorId }) => {
  return (
    <div className="space-y-8">
      {/* Rating Summary */}
      <div className="pb-6 border-b border-gray-200">
        <div className="flex flex-col lg:flex-row items-start gap-8">
          {/* Overall Rating */}
          <div>
            <div className="text-4xl sm:text-5xl font-light text-black mb-3">{serviceRating.toFixed(1)}</div>
            <div className="flex mb-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star 
                  key={star} 
                  className={`w-4 h-4 sm:w-5 sm:h-5 ${
                    star <= Math.floor(serviceRating) 
                      ? 'text-black fill-current' 
                      : 'text-gray-300'
                  }`} 
                />
              ))}
            </div>
            <div className="text-sm sm:text-base text-gray-600 font-light">Based on {serviceReviews} reviews</div>
          </div>

          {/* Rating Breakdown */}
          <div className="flex-1 w-full">
            <h4 className="text-sm sm:text-base font-light text-black mb-4">Rating Distribution</h4>
            <div className="space-y-3">
              {[5, 4, 3, 2, 1].map((rating) => {
                const count = serviceRatingStats[`${rating === 5 ? 'five' : rating === 4 ? 'four' : rating === 3 ? 'three' : rating === 2 ? 'two' : 'one'}_star`] || 0;
                const percentage = serviceReviews > 0 ? (count / serviceReviews) * 100 : 0;
                
                return (
                  <div key={rating} className="flex items-center gap-3">
                    <div className="flex items-center w-8">
                      <span className="text-xs sm:text-sm font-light text-gray-700">{rating}</span>
                      <Star className="w-3 h-3 sm:w-4 sm:h-4 text-black fill-current ml-1" />
                    </div>
                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-black h-2 rounded-full transition-all duration-500"
                        style={{ width: `${percentage}%` }}
                      ></div>
                    </div>
                    <span className="text-xs sm:text-sm text-gray-600 w-12 text-right font-light">{count}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Reviews List */}
      <div>
        {vendorId ? (
          <VendorReviews vendorId={vendorId} />
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
            <Star className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h4 className="text-lg font-light text-black mb-2">No Reviews Yet</h4>
            <p className="text-gray-600 font-light">Be the first to review this service after your booking!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewsTab;

